import React, { Component } from "react";
import axios from "axios";
import {
  API_INFORMES,
  API_INFORMES_PDF,
  TIPO_INFORME_EVAL_AVANCE,
  pdfEvalAvanceScript,
  emptyDatosEvalAvance,
  estadoFirmaEspecialista,
  MSG_FIRMA_PDF_REQUERIDA,
} from "./api";
import FirmaEspecialistaInforme from "./FirmaEspecialistaInforme";
import {
  TIPO_CAMPO,
  CAMPOS_DATOS_GENERALES,
  CAMPOS_CONTEXTO,
  CAMPOS_EVOLUCION,
  CAMPOS_CIERRE,
} from "./camposEvalAvance";

class InformeEvaluacionAvance extends Component {
  constructor(props) {
    super(props);
    this.firmaRef = React.createRef();
    this.state = {
      datos: emptyDatosEvalAvance(),
      guardando: false,
      tieneFirmaEsp: false,
    };
  }

  componentDidMount() {
    this.cargarDatos();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.idInforme !== this.props.idInforme ||
      prevProps.idasociarE !== this.props.idasociarE
    ) {
      this.cargarDatos();
    }
  }

  cargarDatos = () => {
    const { idInforme, cedulaPaciente, idasociarE } = this.props;
    if (idInforme > 0) {
      const data = new FormData();
      data.append("boton", "obtener");
      data.append("idInforme", idInforme);
      data.append("cedulaEspecialista", this.props.cedulaEspecialista || "");
      axios.post(API_INFORMES, data).then((res) => {
        if (res.data.variable1) {
          this.setState({
            datos: res.data.variable3 || emptyDatosEvalAvance(),
          });
        }
      });
      return;
    }
    const data = new FormData();
    data.append("boton", "datosPacienteBase");
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("idasociarE", idasociarE);
    data.append("tipoInforme", TIPO_INFORME_EVAL_AVANCE);
    data.append("ramaEspecialidad", this.props.ramaEspecialidad || "OCUPACIONAL");
    axios.post(API_INFORMES, data).then((res) => {
      const dias = Array.isArray(this.props.diasAtencion) ? this.props.diasAtencion : [];
      const nDias = dias.length > 0 ? dias.length : 1;
      const pref = {
        vecesPorSemana: String(Math.min(nDias, 2)),
        diasTerapiaTexto: dias.join(", "),
        nombreTerapeuta: this.props.nombreEspecialista || "",
      };
      if (res.data.variable1) {
        const base = res.data.variable2;
        this.setState({
          datos: {
            ...emptyDatosEvalAvance(),
            ...pref,
            datosGenerales: {
              ...emptyDatosEvalAvance().datosGenerales,
              ...base,
              nombreTerapeuta: pref.nombreTerapeuta || base.nombreTerapeuta || "",
            },
          },
        });
      } else {
        this.setState({
          datos: {
            ...emptyDatosEvalAvance(),
            ...pref,
            datosGenerales: {
              ...emptyDatosEvalAvance().datosGenerales,
              nombreTerapeuta: pref.nombreTerapeuta,
            },
          },
        });
      }
    });
  };

  setDg = (field, value) => {
    this.setState({
      datos: {
        ...this.state.datos,
        datosGenerales: {
          ...this.state.datos.datosGenerales,
          [field]: value,
        },
      },
    });
  };

  setField = (field, value) => {
    this.setState({
      datos: { ...this.state.datos, [field]: value },
    });
  };

  guardar = () => {
    const {
      cedulaPaciente,
      cedulaEspecialista,
      tipoEvaluacion,
      idasociarE,
      idasociarEGrupo,
      sede,
      idInforme,
      onGuardado,
    } = this.props;
    const { datos } = this.state;
    const dg = datos.datosGenerales;
    this.setState({ guardando: true });
    const data = new FormData();
    data.append("boton", "guardar");
    data.append("tipoInforme", TIPO_INFORME_EVAL_AVANCE);
    data.append("ramaEspecialidad", this.props.ramaEspecialidad || "OCUPACIONAL");
    data.append("idInforme", idInforme || 0);
    data.append("cedulaPaciente", cedulaPaciente);
    data.append("cedulaEspecialista", cedulaEspecialista);
    data.append("tipoEvaluacion", tipoEvaluacion);
    data.append("idasociarE", idasociarE);
    const idsGrupo =
      Array.isArray(idasociarEGrupo) && idasociarEGrupo.length > 0
        ? idasociarEGrupo
        : [idasociarE];
    data.append("idasociarEGrupo", idsGrupo.join(","));
    data.append("formato", "UNICO");
    data.append("fechaInforme", dg.fechaInforme);
    data.append("fechaInicioTerapia", dg.fechaInicioTerapia || "");
    data.append("sede", sede || "");
    data.append("usuario", cedulaEspecialista);
    data.append("datosJson", JSON.stringify(datos));
    axios.post(API_INFORMES, data).then((res) => {
      this.setState({ guardando: false });
      if (res.data.variable1) {
        alert("Fue guardado el Informe de avance");
        if (onGuardado) onGuardado(res.data.variable2);
      } else {
        alert(res.data.variable2 || res.data.variable3 || "Error al guardar.");
      }
    });
  };

  imprimir = async () => {
    const { idInforme, cedulaEspecialista, ramaEspecialidad } = this.props;
    const { tieneFirmaEsp } = this.state;
    if (!idInforme) {
      alert("Guarde el informe antes de imprimir.");
      return;
    }
    if (!cedulaEspecialista) {
      alert("No se identifico al especialista en sesion.");
      return;
    }
    let tieneFirma = tieneFirmaEsp;
    if (!tieneFirma) {
      try {
        const est = await estadoFirmaEspecialista(cedulaEspecialista);
        tieneFirma = est.tiene;
        if (tieneFirma) {
          this.setState({ tieneFirmaEsp: true });
        }
      } catch (e) {
        tieneFirma = false;
      }
    }
    if (!tieneFirma) {
      alert(MSG_FIRMA_PDF_REQUERIDA);
      if (this.firmaRef.current && this.firmaRef.current.abrirSelector) {
        this.firmaRef.current.abrirSelector();
      }
      return;
    }
    const script = pdfEvalAvanceScript(ramaEspecialidad || "OCUPACIONAL");
    if (!script) {
      alert("No hay plantilla PDF para esta especialidad.");
      return;
    }
    const urlPdf =
      API_INFORMES_PDF +
      script +
      "?idInforme=" +
      encodeURIComponent(String(idInforme));
    const data = new FormData();
    data.append("idInforme", idInforme);
    axios({
      method: "post",
      url: API_INFORMES_PDF + script,
      responseType: "arraybuffer",
      data,
    })
      .then((response) => {
        const buf = response.data;
        if (!buf || buf.byteLength < 100) {
          window.open(urlPdf, "_blank");
          return;
        }
        const u8 = new Uint8Array(buf);
        const esPdf =
          u8.length >= 4 &&
          u8[0] === 0x25 &&
          u8[1] === 0x50 &&
          u8[2] === 0x44 &&
          u8[3] === 0x46;
        if (!esPdf) {
          window.open(urlPdf, "_blank");
          return;
        }
        const blob = new Blob([buf], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob));
      })
      .catch(() => {
        window.open(urlPdf, "_blank");
      });
  };

  renderControl = (config, value, onChange) => {
    const tipo = config.tipo || TIPO_CAMPO.MULTILINEA;
    if (tipo === TIPO_CAMPO.FECHA) {
      return (
        <input
          type="date"
          className="ic-input ic-input-line"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    if (tipo === TIPO_CAMPO.MULTILINEA || config.rows) {
      return (
        <textarea
          className="ic-textarea"
          rows={config.rows || 4}
          maxLength={config.maxLength || 2000}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    }
    return (
      <input
        type="text"
        className="ic-input ic-input-line"
        maxLength={config.maxLength || 120}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  };

  renderCampoDg = (config) => {
    const dg = this.state.datos.datosGenerales;
    const val = config.key === "edadTexto" ? dg.edadTexto || dg.edad || "" : dg[config.key];
    return (
      <div className="ic-field" key={config.key}>
        <label className="ic-label">{config.label}</label>
        {this.renderControl(config, val, (v) => this.setDg(config.key, v))}
      </div>
    );
  };

  renderCampoRaiz = (config) => (
    <div className="ic-field" key={config.key}>
      <label className="ic-label">{config.label}</label>
      {this.renderControl(config, this.state.datos[config.key], (v) =>
        this.setField(config.key, v)
      )}
    </div>
  );

  renderSeccion = (titulo, children) => (
    <div className="ic-formSection">
      <h4>{titulo}</h4>
      {children}
    </div>
  );

  render() {
    const { guardando } = this.state;
    const numeroAvance = this.props.numeroAvance || "";

    return (
      <div className="ic-panel ic-form-document">
        <p>
          Paciente:{" "}
          <strong>{this.props.nombrePaciente || this.props.cedulaPaciente}</strong>
        </p>
        <p className="ic-formato-badge">
          <strong>
            Reporte de evolución — Terapia Ocupacional
            {numeroAvance ? ` (Avance ${numeroAvance})` : ""}
          </strong>
        </p>
        <div className="ic-actions ic-actions-sticky">
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>

        {this.renderSeccion(
          "Introducción",
          <>
            <p className="ic-plantilla-texto">
              El siguiente reporte describe los avances en las áreas indicadas y el contexto de
              asistencia del paciente.
            </p>
            <div className="ic-grid-campos">
              {CAMPOS_CONTEXTO.map((c) => this.renderCampoRaiz(c))}
            </div>
          </>
        )}

        {this.renderSeccion(
          "Evolución terapéutica",
          <div className="ic-grid-campos">
            {CAMPOS_EVOLUCION.map((c) =>
              this.renderCampoRaiz({ ...c, tipo: TIPO_CAMPO.MULTILINEA })
            )}
          </div>
        )}

        {this.renderSeccion(
          "Datos generales",
          <div className="ic-grid-datos">
            {CAMPOS_DATOS_GENERALES.map((c) => this.renderCampoDg(c))}
          </div>
        )}

        {this.renderSeccion(
          "Conclusión y recomendaciones",
          <div className="ic-grid-campos">
            {CAMPOS_CIERRE.map((c) =>
              this.renderCampoRaiz({ ...c, tipo: TIPO_CAMPO.MULTILINEA })
            )}
          </div>
        )}

        <FirmaEspecialistaInforme
          ref={this.firmaRef}
          cedulaEspecialista={this.props.cedulaEspecialista}
          onCambio={(tiene) => this.setState({ tieneFirmaEsp: tiene })}
        />

        <div className="ic-actions">
          <button type="button" className="boton" onClick={this.guardar} disabled={guardando}>
            {guardando ? "Guardando..." : "Guardar"}
          </button>
          <button type="button" className="boton" onClick={this.imprimir}>
            Imprimir PDF
          </button>
          {this.props.idInforme > 0 && this.props.onEliminar && (
            <button
              type="button"
              className="boton ic-btn-danger"
              onClick={() => this.props.onEliminar(this.props.idInforme)}
            >
              Eliminar informe
            </button>
          )}
          <button type="button" className="boton" onClick={this.props.onVolver}>
            Volver
          </button>
        </div>
      </div>
    );
  }
}

export default InformeEvaluacionAvance;
